import React from 'react'
import Message from 'portal-modules/common/components/Message'
import { AlertTriangle } from '@entrata/portals-common/lib/icons'

const SignUpBtns = [
  {
    name: __('Sign Up'),
    onClick: () => {
      console.log('Sign Up')
    },
  },
  {
    name: __('No Thanks'),
    onClick: () => {
      handleCancel()
    },
  },
]

const handleCancel = () => {
  console.log('Handling Cancel Event.')
}

const SignUpMessage = props => (
  <Message {...props} Icon={AlertTriangle} actions={SignUpBtns}>
    {__("You haven't signed up for text message property alerts and messages.")}
  </Message>
)

export default SignUpMessage
